import { useSelector } from 'react-redux';
import { ACL, UserCan } from '../shared/constants';
import { iFullStoreState, ItemType } from '../shared/interfaces';
import { useIsReadOnly } from './useIsReadOnly';

export const useCanEditNotes = (
  itemId: string,
  itemType: ItemType
): { disabled: boolean } => {
  const isReadOnly = useIsReadOnly(itemId, itemType);

  const userCanDo = useSelector<iFullStoreState, Array<string>>(
    (s) => s.auth.user?.acl?.can
  );

  const canEditNotes = ACL.check(UserCan.EDIT_NOTES, userCanDo, true);

  return {
    disabled: isReadOnly && !canEditNotes,
  };
};

